import { useNavigate } from "react-router-dom";
import allProblems from "../Data/Problems.json"

export default function useRedirectToProblem() { // Has to be named with prefix 'use' bucause it calls a hook (useNavigate)
    const navigate = useNavigate();
    return (problemID) => {
        if (problemID === null) throw new Error("Missing problem id in useRedirectToProblem")
        const modality = allProblems.find(prob => prob.problem_id == problemID).problem_modality;
        if(modality === "Code") return navigate('/ProblemCode', { state: { problem_id : problemID } })
        else if(modality === "MCQ") return   navigate('/ProblemMCQ', { state: { problem_id : problemID } })
        throw new Error(`Problem ${problemID} has an invalid modality: ${modality}`);
    };
}

